import { DefaultTemplate } from "./defaultTemplate";
import { MailRoomFlexibleTemplate } from "./mailRoomFlexibleTemplate";
import { NewlyNotReportingT2MTemplate, NewlyNotReportingAZTemplate, NewlyNotReportingFLTemplate, NewlyNotReportingIDTemplate, NewlyNotReportingNJTemplate, NewlyNotReportingWATemplate, NewlyNotReportingGeneralTemplate, } from "./newlyNotReporting";
import { OhioSercTemplate } from "./ohioSercTemplate";
import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
import { TemplateName } from "./types";
const TEMPLATE_FACTORIES = {
    [TemplateName.TierIIEmailSingle]: () => new TierIIEmailTemplate().toTemplate(),
    [TemplateName.TierIIEmailBulk]: () => new TierIIEmailTemplate().toTemplate(),
    [TemplateName.TierIIEmail]: () => new TierIIEmailTemplate().toTemplate(),
    [TemplateName.OhioSerc]: () => new OhioSercTemplate().toTemplate(),
    [TemplateName.MailRoomFlexible]: () => new MailRoomFlexibleTemplate().toTemplate(),
    [TemplateName.Default]: () => new DefaultTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingGeneral]: () => new NewlyNotReportingGeneralTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingT2M]: () => new NewlyNotReportingT2MTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingAZ]: () => new NewlyNotReportingAZTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingFL]: () => new NewlyNotReportingFLTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingID]: () => new NewlyNotReportingIDTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingNJ]: () => new NewlyNotReportingNJTemplate().toTemplate(),
    [TemplateName.NewlyNotReportingWA]: () => new NewlyNotReportingWATemplate().toTemplate(),
};
export function getTemplate(name) {
    const factory = TEMPLATE_FACTORIES[name];
    return factory ? factory() : TEMPLATE_FACTORIES[TemplateName.Default]();
}
//# sourceMappingURL=hydrator.js.map